import { TypedDocumentNode } from '@apollo/client'
import { Mutation, Query, Subscription } from '@src/graphql-types.ts'
import base64 from 'base-64'
import fraql from 'fraql'
import { isArray, isObject } from 'lodash'

/**
 * This allows us to use fraql but trigger IDE-based plugins for graphql parsing
 * @param literals
 * @param args
 */
export function gql(
  literals: string | readonly string[],
  ...args: any[]
): TypedDocumentNode<Query & Mutation & Subscription> {
  let result
  try {
    result = fraql(literals, ...args)
  } catch (err) {
    console.log(`INVALID QUERY: ${literals}`)
    throw err
  }

  return result
}

export function gqlVars(
  args: string[] | object = [],
  defaultValue: any = '',
  wrappers: string[] = ['(', ')'],
  separator: string = ', '
) {
  return gqlArgs(args, defaultValue, wrappers, separator)
}

/**
 * Generate graphql definition statement for argument statements
 */
export function gqlArgs(
  args: string[] | object = [],
  defaultValue: any = '',
  wrappers: string[] = [],
  separator: string = ', '
) {
  let results: Array<string | boolean> = []

  if (isArray(args)) {
    results = args.filter(Boolean)
  } else {
    Object.keys(args).forEach(key => {
      if (isArray(args[key]) || isObject(args[key])) {
        const result = gqlArgs(args[key], false, ['{', '}', ', '])
        if (result) {
          results.push(`${key} ${result}`)
        }
      } else if (args[key]) {
        results.push(key)
      }
    })
  }

  if (results.length > 0) {
    return `${wrappers[0] || ''} ${results.join(separator)} ${wrappers[1] || ''}`
  } else {
    return defaultValue
  }
}

export const fromGlobalId = id => {
  return base64.decode(id).split(':')
}

export const toGlobalId = (type, id) => {
  return base64.encode(`${type}:${id}`)
}
